import React, { type FC } from 'react';
import { TextButton, Tooltip } from '@wix/design-system';
import { useTemplatesPageBi } from '../../hooks/useTemplatesPageBi';
import { useTemplatesData } from '../../hooks/useTemplatesData';

type Props = {
  href: string;
  title: string;
  content: string;
};

export const LinkMarkdown: FC<Props> = ({ href, title, content }) => {
  const { reportMarkdownLinkClicked } = useTemplatesPageBi();
  const { currentTemplate: template } = useTemplatesData();

  const reportLinkClicked = () => {
    reportMarkdownLinkClicked(template.id, href, content);
  };

  const onClick = () => {
    reportLinkClicked();
    window.open(href, '_blank');
  };

  const getTextButton = () => (
    <TextButton as="a" underline="onHover" onClick={onClick}>
      {content}
    </TextButton>
  );

  return title ? (
    <Tooltip inline content={title} textAlign="center" size="small">
      {getTextButton()}
    </Tooltip>
  ) : (
    getTextButton()
  );
};
